export function diferencaDatasEmMeses(dataInicio, dataFim) {

  let inicio = ''
  let fim = ''
  if (dataInicio.includes('/')) {
    const [dia1, mes1, ano1] = dataInicio.split('/').map(Number);
    inicio = new Date(ano1, mes1 - 1, dia1);
  } else {
    inicio = new Date(dataInicio);
  }

  if (dataFim.includes('/')) {
    const [dia1, mes1, ano1] = dataFim.split('/').map(Number);
    fim = new Date(ano1, mes1 - 1, dia1);
  } else {
    fim = new Date(dataFim);
  }


  const diferencaEmMilissegundos = fim - inicio;
  const milissegundosPorDia = 24 * 60 * 60 * 1000;

  const diferencaEmDias = diferencaEmMilissegundos / milissegundosPorDia;
  const diferencaEmMeses = diferencaEmDias / 30.44; // Média de dias em um mês

  return Math.floor(diferencaEmMeses);
};